import { Controller } from "stimulus"
import $ from 'jquery';

import flatpickr from "flatpickr";
import {Spanish} from "flatpickr/dist/l10n/es.js"
require("flatpickr/dist/themes/airbnb.css")

export default class extends Controller {

    connect() {

            flatpickr(".datepicker", {
                altInput: true,
                altFormat: "d-m-Y",
                dateFormat: "Y-m-d",
                minDate: "today",
                locale: Spanish,
                disableMobile: "true"
            })

            flatpickr(".timepicker", {
                enableTime: true,
                noCalendar: true,
                dateFormat: "h:i",
                time_24hr: false,
                locale: Spanish,
                disableMobile: "true"
            })

        flatpickr("#date_range", {
            mode: "range",
            dateFormat: "Y-m-d",
            locale: Spanish,
            minDate: "today",
            showMonths: 1,
            onReady: function(selectedDates, dateString, instance) {
                // Establecer placeholder inicial si no hay valor
                if (!instance.input.value.trim()) {
                    instance.input.setAttribute("placeholder", I18n.t('home.page.select_range_date'));
                }
            },
            onValueUpdate: function(selectedDates, dateString, instance) {
                // Si el campo queda vacío (ej. usuario borra), restaurar placeholder
                if (!dateString) {
                    instance.input.setAttribute("placeholder", I18n.t('home.page.select_range_date'));
                } else {
                    instance.input.removeAttribute("placeholder");
                }
            }
        });
        flatpickr("#hotetec_date_range", {
            mode: "range",
            dateFormat: "Y-m-d",
            locale: Spanish,
            minDate: "today",
            showMonths: 1,
            onReady: function(selectedDates, dateString, instance) {
                // Establecer placeholder inicial si no hay valor
                if (!instance.input.value.trim()) {
                    instance.input.setAttribute("placeholder", I18n.t('home.page.select_range_date'));
                }
            },
            onValueUpdate: function(selectedDates, dateString, instance) {
                // Si el campo queda vacío (ej. usuario borra), restaurar placeholder
                if (!dateString) {
                    instance.input.setAttribute("placeholder", I18n.t('home.page.select_range_date'));
                } else {
                    instance.input.removeAttribute("placeholder");
                }
            }
        });
    }
}